export default "__VITE_PUBLIC_ASSET__db8b51e4__"